module.exports = __webpack_public_path__ + "img/清醒的沉溺.0487b88d.jpg";